var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quality-badge max-w-xxs",class:{ success: _vm.success, warn: _vm.warn, error: _vm.error }},[_c('p',{staticClass:"p5 my-auto px-1 mx-auto"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }